import React, { useState, useEffect } from "react";


interface ToothChartProps {
    selectedTeeth: Record<number, string>;
    onToothClick?: (toothNumber: number) => void;
}

const upperTeeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
const lowerTeeth = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

const spacing = 45;
const scale = 0.6;
const chartWidth = spacing * upperTeeth.length;

const ToothChart: React.FC<ToothChartProps> = ({ selectedTeeth, onToothClick }) => {
    const [hoveredTooth, setHoveredTooth] = useState<number | null>(null);

const [prefersDarkMode, setPrefersDarkMode] = useState(false);

useEffect(() => {
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  setPrefersDarkMode(mediaQuery.matches);

  const handler = (e: MediaQueryListEvent) => setPrefersDarkMode(e.matches);

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(handler);
    return () => mediaQuery.removeListener(handler);
  }
}, []);



    const renderTeethRow = (teeth: number[], baseY: number, curveDirection = 1) =>
        teeth.map((num, index) => {
            const x = index * spacing;
            const offsetX = (900 - chartWidth) / 2; // center alignment in 900px viewBox
            const curve = Math.sin((index / (teeth.length - 1)) * Math.PI) * 8 * curveDirection; // smooth arc

            const isHovered = hoveredTooth === num;
            const fillColor = selectedTeeth[num] || "transparent";

            const isGrayTooth = !prefersDarkMode && fillColor === "transparent" && num <= 20;


            return (
                <g
                    key={num}
                    transform={`translate(${offsetX + x}, ${baseY + curve}) scale(${scale * (isHovered ? 1.2 : 1)})`}
                    onClick={() => onToothClick?.(num)}
                    onMouseEnter={() => setHoveredTooth(num)}
                    onMouseLeave={() => setHoveredTooth(null)}
                    style={{ cursor: "pointer", transition: "transform 0.2s ease-in-out" }}
                >





                    {/* Fundal pentru selecție */}
                    {fillColor !== "transparent" && (
                        <rect x={0} y={0} width={80} height={100} rx={10} fill={fillColor} opacity={0.3} />
                    )}

                    {/* SVG real */}
                    <image
                        href={`/svg/${num}.svg`}
                        width={80}
                        height={100}
                        style={{
                            filter: isHovered
                                ? "drop-shadow(0 0 3px #22c55e)"
                                : isGrayTooth
                                    ? "grayscale(100%) brightness(0.4)"
                                    : "none",
                            opacity: 1,
                            transition: "filter 0.2s ease-in-out, opacity 0.2s ease-in-out",
                        }}
                    />

                    {/* Numărul dintelui */}
                    <text
                        x={40}
                        y={num >= 31 && num <= 48 ? 125 : -10} // pentru dinții de sus: y negativ
                        textAnchor="middle"
                        fontSize={16}
                        fill={isHovered ? "#22c55e" : prefersDarkMode ? "#fff" : "#000"}
                    >
                        {num}
                    </text>
                </g>
            );
        });

    return (
        <svg viewBox="0 -30 900 300" width="100%" height="auto" preserveAspectRatio="xMidYMid meet">
            {renderTeethRow(upperTeeth, 20, -1)} {/* curbă în sus */}
            {renderTeethRow(lowerTeeth, 160, 1)} {/* curbă în jos */}
        </svg>
    );
};

export default ToothChart;
